import { ShipmentDto } from '@/services/semen-service';

export const convertGridSortToOrderBy = (
  sortModel: { colId: string; sort: string; sortIndex: number }[],
): string | null => {
  if (!sortModel || sortModel.length === 0) {
    return null;
  }

  return sortModel
    .sort((a, b) => a.sortIndex - b.sortIndex)
    .map((sort) => {
      const direction = sort.sort === 'asc' ? ' asc' : ' desc';
      return `${sort.colId}${direction}`;
    })
    .join(', ');
};

export const getMissingShipmentFields = (
  selectedShipment: ShipmentDto | null,
) => {
  const missingFields: string[] = [];

  if (!selectedShipment?.ownerId) {
    missingFields.push('Account');
  }
  if (selectedShipment?.shippingMethod == null) {
    missingFields.push('Shipping Method');
  }
  if (!selectedShipment?.billTo) {
    missingFields.push('Bill To');
  }
  if (selectedShipment?.shipmentStatus == null) {
    missingFields.push('Shipment Status');
  }
  if (!selectedShipment?.shipFromSiteId) {
    missingFields.push('Ship From Site');
  }
  if (!selectedShipment?.needByDate) {
    missingFields.push('Need By Date');
  }
  if (!selectedShipment?.shipName) {
    missingFields.push('Ship To/Ship Name');
  }
  if (!selectedShipment?.shipAddress) {
    missingFields.push('Ship Address');
  }
  if (!selectedShipment?.shipCity) {
    missingFields.push('Ship City');
  }
  if (!selectedShipment?.shipState) {
    missingFields.push('Ship State');
  }
  if (!selectedShipment?.shipZip) {
    missingFields.push('Shipment ZIP');
  }
  if (!selectedShipment?.hasEmbryos && !selectedShipment?.hasSemen) {
    missingFields.push('Contains: embryos, semen');
  }

  return missingFields;
};
